<!-- Delete this file later, check if this effects Softpay refund on TastyOrder app -->
<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div v-if="!loading" class="mt-4 mb-4" style="max-width:560px">
        <OrderDetail :dataForOrderDetail="dataForOrderDetail" @open-order="openOrder"/>
      </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import OrderService from "@/services/order/OrderService";
import OrderDetail from "@/components/order/OrderDetail.vue";

export default {
  components: {OrderDetail, LoadingSpinner},
  data() {
    return {
      loading: true,

      orderDocumentId: '',
      dataForOrderDetail: {}
    };
  },
  mounted() {
    this.load(this.$route.query.orderDocumentId);
  },
  watch: {
    // A delregning's table, or one of its delregninger, opened from the page: the same page, another order.
    '$route.query.orderDocumentId'(orderDocumentId) {
      if (orderDocumentId && orderDocumentId !== this.orderDocumentId) {
        this.load(orderDocumentId);
      }
    }
  },
  methods: {
    load(orderDocumentId) {
      this.loading = true;
      this.orderDocumentId = orderDocumentId;
      OrderService.getDataForOrderDetailGui(this.orderDocumentId).then(
          (response) => {
            this.dataForOrderDetail = response.data;

            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    openOrder(orderDocumentId) {
      this.$router.push({ path: 'orderDetail', query: { orderDocumentId } });
    }
  }
}
</script>

